import axiosClient from "@/utils/axios-client";
import {
  GetCreditInvoiceListRequest,
  GetCreditInvoiceListResponse,
  GetUnoFeeListRequest,
  GetUnoFeeListResponse,
} from "@/features/my-order/features/settlement-management/types";
import { toSnakeKeyObject } from "@/utils/case";

const url = {
  getUnoFeeList: (companyType: string, companyId: number) =>
    `/${companyType}/${companyId}/uno-fees`,
  getCreditInvoiceList: (companyType: string, companyId: number) =>
    `/${companyType}/${companyId}/credit-invoices`,
};

export const settlementManagementApi = {
  getUnoFeeList: async (
    companyType: string,
    companyId: number,
    params: GetUnoFeeListRequest
  ) => {
    const { data } = await axiosClient.get<GetUnoFeeListResponse>(
      url.getUnoFeeList(companyType, companyId),
      { params }
    );

    return data;
  },
  getCreditInvoiceList: async (
    companyType: string,
    companyId: number,
    params?: GetCreditInvoiceListRequest
  ) => {
    const { data } = await axiosClient.get<GetCreditInvoiceListResponse>(
      url.getCreditInvoiceList(companyType, companyId),
      { params: toSnakeKeyObject(params) }
    );

    return data;
  },
};
